"use client";

import { useData } from "data/data-provider";
import EndDateTimeRange from "designs/Common/(car-search-form)/endDateTIme";
import StartDateTimeRange from "designs/Common/(car-search-form)/startDateTime";
import DropOffLocationInput from "designs/Common/DropOffLocationInput";
import LocationInput from "designs/Common/LocationInput";
import { set } from "lodash";
import { FC, useEffect } from "react";
import { start } from "repl";
import { LOCATION_COPY } from "config/locationCopy";

export interface RentalCarSearchFormProps {}

const RentalCarSearchForm: FC<RentalCarSearchFormProps> = () => {
  const {
    setDropoffLocationType,
    dropoffLocationType,
    setSelectedWeeks,
    setSelectedMonth,
    setEndDate,
    setStartDate,
    setPickupLocation,
    setDropoffLocation,
    setStartTime,
    setEndTime,
    startDate,
    endDate,
    setActiveTab,
    ourLocation,
  } = useData();

  useEffect(() => {
    setActiveTab("dates");
    setSelectedWeeks([]);
    setSelectedMonth(0);
    setStartDate(null);
    setEndDate(null);
    const activeLocations = ourLocation.filter((loc) => loc.active !== false);
    if (activeLocations.length !== 1) {
      setPickupLocation(null);
      setDropoffLocation(null);
    }
    setDropoffLocationType(true);
    setStartTime("07:00");
    setEndTime("19:00");
  }, []);

  const isDdropOffdifferent = dropoffLocationType === false;
  const hasDropoffLocations = ourLocation.some(
    (loc) =>
      loc.active !== false &&
      (loc.location_type === "drop_off" || loc.location_type === "both")
  );
  const showSeparate = isDdropOffdifferent && hasDropoffLocations;

  return (
    <form className="w-full relative mt-8 rounded-xl shadow-xl bg-secondary-50/80 backdrop-blur-sm">
      <div className={`relative flex flex-row items-center py-2`}>
        <LocationInput
          placeHolder={
            isDdropOffdifferent
              ? LOCATION_COPY.pickUp.label
              : LOCATION_COPY.same.label
          }
          desc={
            isDdropOffdifferent
              ? LOCATION_COPY.pickUp.prompt
              : LOCATION_COPY.same.prompt
          }
          className="flex-1 ps-2"
          sameDropOffLocation={dropoffLocationType === false}
          onShowDropoffLocation={() => setDropoffLocationType(false)}
        />
        {isDdropOffdifferent && (
          <>
            <div className="self-center border-r border-secondary-100 h-8"></div>
            <DropOffLocationInput
              placeHolder={LOCATION_COPY.dropOff.label}
              desc={LOCATION_COPY.dropOff.prompt}
              className="flex-1"
              divHideVerticalLineClass="-inset-x-0.5"
            />
          </>
        )}

        <div className="self-center border-r border-secondary-100 h-8"></div>
        <StartDateTimeRange className="flex-1 w-[280px]" />

        <div className="self-center border-r border-secondary-100 h-8"></div>
        <EndDateTimeRange
          className="flex-1 w-[280px]"
          dropOffLocationType={dropoffLocationType}
          design="designA"
        />
      </div>
    </form>
  );
};

export default RentalCarSearchForm;
